import { formatServerTime } from '@foodrun/shared';

/**
 * Turning what the server stores into what a bill says.
 *
 * Separate from the bill itself so it can be tested directly — these are the
 * parts where a wrong answer prints on paper and reaches a customer.
 */

/**
 * A date a person can read.
 *
 * Read as UTC and shown in the reader's own time — see parseServerTime in
 * @foodrun/shared for why both halves of that matter.
 */
export const formatWhen = formatServerTime;

/** "dine_in" is how the database spells it, not how anyone reads it. */
export function readableType(type) {
  return (
    {
      dine_in: 'Dine in',
      takeaway: 'Takeaway',
      delivery: 'Delivery',
      foodpanda: 'Foodpanda',
      phone_order: 'Phone order',
      online: 'Online',
      complimentary: 'Complimentary',
      staff_meal: 'Staff meal',
    }[type] ?? type
  );
}

export function readableMethod(method) {
  return { cash: 'Cash', card: 'Card', online: 'Online', wallet: 'Wallet' }[method] ?? method;
}
